import { cloneDeep } from 'lodash';
import { getRequest } from '../../util/Request';
import SelectProfileStoreModuleExtensions from './SelectProfileStoreModuleExtensions';

const request = getRequest();

const state = () => {
    return { profiles: [] };
};

const getters = {
    // return getters as functions to prevent caching at the getter level
    // calling code must invoke $store.getters.getXXX();
    // each getter performs a clone on object responses in order to keep the store
    // state clean (ie. nothing outside the store can inadvertently or directly change
    // the state)

    getProfiles: state => (() => {
        return cloneDeep(state.profiles);
    })

};

const mutations = {
    profiles: (state, profiles) => {
        state.profiles = profiles;
    }
};

const actions = {

    retrieveProfiles: () => {
        return new Promise((resolve, reject) => {
            request.get(
                '/site/myresources/sso/profiles'
            ).then(({ data }) => {
                resolve(data);
            }).catch(reject);
        });
    },

    authenticate: (context, credentials) => {
        return new Promise((resolve, reject) => {
            request.post(
                '/auth/authentication/constituent',
                {
                    ...credentials,
                    lineOfBusiness: 'VACCN'
                },
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
            ).then(({ data }) => {
                resolve(data);
            }).catch(reject);
        });
    }

};


new SelectProfileStoreModuleExtensions(request);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
